import { lazy } from 'react';

const Login = lazy(() => import('../pages/Login'));
const Device = lazy(() => import('../pages/Device'));
const CarCard = lazy(() => import('../pages/CarCard'));
const ControlCard = lazy(() => import('../pages/ControlCard'));
const NewUserCard = lazy(() => import('../pages/NewUserCard'));
const RoleControlCard = lazy(() => import('../pages/RoleControlCard'));
const UserHistoryCard = lazy(() => import('../pages/UserHistoryCard'));
const StatusCard = lazy(() => import('../pages/StatusCard'));
const ForgotPassword = lazy(() => import('../pages/ForgotPassword'));


export const routes = [
  { path: '/', element: Login },
  { path: '/:id', element: Device },
  { path: '/car/:id', element: CarCard },
  { path: '/control', element: ControlCard, private: true },
  { path: '/newuser', element: NewUserCard, private: true },
  { path: '/rolecontrol', element: RoleControlCard, private: true },
  { path: '/userhistory', element: UserHistoryCard, private: true },
  { path: '/totem/:id', element: StatusCard },
  { path: '/forgotpassword', element: ForgotPassword }
];